import React from 'react';
import { CheckCircleIcon, FaceSmileIcon, CalendarIcon, DeviceTabletIcon } from '@heroicons/react/24/outline';

const About = () => {
  const features = [
    { icon: <CheckCircleIcon className="w-6 h-6 text-blue-500" />, text: "Approche technologique innovante" },
    { icon: <FaceSmileIcon className="w-6 h-6 text-emerald-500" />, text: "Montures adaptées à votre morphologie" },
    { icon: <CalendarIcon className="w-6 h-6 text-amber-500" />, text: "Prise de rendez-vous en ligne" },
    { icon: <DeviceTabletIcon className="w-6 h-6 text-indigo-500" />, text: "Suivi visuel digital personnalisé" },
  ];

  return (
    <section className="py-24 bg-white border-t border-slate-100 opacity-0 animate-fadeIn scroll-mt-20" id="about">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl font-black text-slate-900 mb-6">Pourquoi AfroOptic ?</h2>
          <p className="text-slate-600 text-lg leading-relaxed">
            Nous œuvrons à rendre les solutions optiques accessibles, innovantes et adaptées aux réalités locales africaines.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div className="bg-slate-50 p-8 rounded-3xl border border-slate-100">
              <h3 className="text-2xl font-bold text-slate-900 mb-4">Notre Mission</h3>
              <p className="text-slate-600 leading-relaxed">
                Améliorer la santé visuelle en Afrique par la prévention, la recherche et l’éducation.
              </p>
            </div>
            <div className="bg-blue-600 p-8 rounded-3xl text-white shadow-xl shadow-blue-100">
              <h3 className="text-2xl font-bold mb-4 text-white">Notre Histoire</h3>
              <p className="text-blue-50 leading-relaxed">
                Né du désir de jeunes engagés de faciliter l'accès aux produits optiques de qualité au Sénégal et partout en Afrique.
              </p>
            </div>
          </div>

          <div className="bg-white p-8 rounded-3xl border border-slate-100 shadow-sm">
            <h3 className="text-2xl font-bold text-slate-900 mb-8">Ce qui nous distingue</h3>
            <ul className="space-y-6">
              {features.map((f, i) => (
                <li key={i} className="flex items-center gap-4 p-4 rounded-2xl hover:bg-slate-50 transition-colors">
                  <div className="p-3 bg-white rounded-xl shadow-sm border border-slate-100">{f.icon}</div>
                  <span className="text-slate-700 font-medium">{f.text}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;